import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

import { Icon } from "./";

export function LocationMarkerPicker({ value, onChange }) {
  const [searchVal, setSearchVal] = useState("");
  const [locationOptions, setLocationOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState();
  const [inputFocused, setInputFocused] = useState(false);

  const inputRef = useRef();
  const dropdownRef = useRef();

  const { items: markers } = useSelector((state) => state.markers);
  const { items: maps } = useSelector((state) => state.maps);

  const handleUpdate = (item) => {
    if (item) {
      setSelectedValue(item);
      setInputFocused(false);
      if (onChange) {
        onChange(item._id);
      }
    }
  };

  useEffect(() => {
    const searchStr =
      searchVal && searchVal.length > 0 ? searchVal.toLowerCase() : undefined;
    const filteredLocations = !markers
      ? []
      : markers
          .filter(
            (m) => m.title.toLowerCase().indexOf(searchVal.toLowerCase()) > -1
          )
          .sort((a, b) => {
            if (searchStr) {
              return a.title.toLowerCase().indexOf(searchStr) <
                b.title.toLowerCase().indexOf(searchStr)
                ? -1
                : 1;
            } else {
              return a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1;
            }
          })
          .map((location) => {
            const parentMap = maps.find((m) => m._id === location.parentMap);

            return (
              <LocationPickerOption
                item={location}
                update={handleUpdate}
                parentMap={parentMap}
                key={location._id}
              />
            );
          });

    setLocationOptions(filteredLocations);
  }, [markers, searchVal]);

  useEffect(() => {
    if (value && markers) {
      const defValue = markers.find((m) => m._id === value);
      if (defValue) {
        setSelectedValue(defValue);
      }
    }
  }, [value]);

  const handleInputChange = (ev) => {
    const { value } = ev.target;
    setSearchVal(value);
  };

  const handleClear = () => {
    setSelectedValue(null);
    setSearchVal("");
    if (onChange) {
      onChange(null);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (ev) => {
      // console.log(ev);
      if (inputRef.current && !inputRef.current.contains(ev.target)) {
        setInputFocused(false);
      }
    };

    if (inputFocused) {
      window.addEventListener("click", handleOutsideClick);
    }

    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, [inputFocused]);

  return (
    <div className="chronos-location-picker">
      <div className="chronos-location-picker-search chronos-list-search">
        {selectedValue && (
          <div className="chronos-location-picker-selected-option">
            <span className="chronos-location-picker-option-icon">
              <Icon
                icon={
                  selectedValue.icon && selectedValue.icon.length > 0
                    ? selectedValue.icon
                    : "far fa-map-pin fa-fw"
                }
              />
            </span>
            <span className="chronos-location-picker-option-label">
              {selectedValue.title}
            </span>
          </div>
        )}
        {!selectedValue && (
          <input
            className="chronos-location-picker-input chronos-search-input"
            value={searchVal}
            onChange={handleInputChange}
            // autoComplete="new-password"
            autoComplete="offer"
            spellCheck={false}
            ref={inputRef}
            onFocus={() => setInputFocused(true)}
            disabled={markers.length === 0}
            placeholder={
              markers.length === 0
                ? "You have no markers created. Right click anywhere on your map to create one."
                : "Search Markers"
            }
            style={{ fontSize: "0.85rem" }}
          />
        )}

        <button
          type="button"
          onClick={handleClear}
          className="chronos-location-picker-clear"
        >
          <Icon icon="fas fa-times text-muted" />
        </button>
      </div>
      <div
        className={
          "chronos-location-picker-dropdown" + (inputFocused ? " active" : "")
        }
        ref={dropdownRef}
      >
        <ul className="chronos-location-picker-options">
          {locationOptions.length > 0 ? (
            locationOptions
          ) : (
            <LocationPickerEmptyOption />
          )}
        </ul>
      </div>
      {/* {inputRef.current && document.activeElement === inputRef.current && (
        <div className="chronos-location-picker-dropdown">
          <ul className="chronos-location-picker-options">
            {locationOptions.length > 0 ? (
              locationOptions
            ) : (
              <LocationPickerEmptyOption />
            )}
          </ul>
        </div>
      )} */}
    </div>
  );
}

function LocationPickerOption({ item, update, parentMap = null }) {
  let icon = item.icon && item.icon.length > 0 ? item.icon : "far fa-map-pin";
  if (icon.substr(0, 2) === "fa") {
    icon += " fa-fw";
  } else if (icon.substr(0, 2) === "ra") {
    icon += " ra-fw";
  }
  const handleSelect = () => {
    update(item);
  };

  let mapName = "";
  if (parentMap !== null && parentMap.title !== undefined) {
    mapName = parentMap.title;
  }

  return (
    <li className="chronos-location-picker-option" onClick={handleSelect}>
      <span className="chronos-location-picker-option-icon">
        <Icon icon={icon} />
      </span>
      <span className="chronos-location-picker-option-label">
        <span className="chronos-location-picker-option-marker-name">
          {item.title}
        </span>
        {mapName.length > 0 && (
          <span className="chronos-location-picker-option-map-name">
            {`(${mapName})`}
          </span>
        )}
      </span>
    </li>
  );
}

function LocationPickerEmptyOption() {
  return (
    <li className="chronos-location-picker-option chronos-location-option-empty">
      No Results Found.
    </li>
  );
}
